import { __assign, __rest } from "tslib";
import React, { forwardRef } from "react";
import classNames from "classnames";
import { createRocket } from "../_util/create-rocket";
import { Icon } from "../icon";
import { Justify } from "../justify";
import { useConfig } from "../_util/config-context";
export var LayoutContentHeader = forwardRef(function LayoutContentHeader(_a, ref) {
    var showBackButton = _a.showBackButton, _b = _a.onBackButtonClick, onBackButtonClick = _b === void 0 ? function () { return null; } : _b, title = _a.title, subtitle = _a.subtitle, children = _a.children, operation = _a.operation, className = _a.className, props = __rest(_a, ["showBackButton", "onBackButtonClick", "title", "subtitle", "children", "operation", "className"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-layout__content-header", className) }, props),
        React.createElement("div", { className: classPrefix + "-layout__header-title" },
            React.createElement(Justify, { left: React.createElement(React.Fragment, null,
                    showBackButton && (React.createElement("a", { className: classPrefix + "-content__header-back", onClick: onBackButtonClick },
                        React.createElement(Icon, { type: "btnback" }))),
                    React.createElement("h2", { className: classPrefix + "-h2" }, title),
                    children,
                    subtitle && (React.createElement("span", { className: classPrefix + "-layout__header-text" }, subtitle))), right: operation }))));
});
LayoutContentHeader.displayName = "LayoutContentHeader";
export var LayoutContentBody = forwardRef(function LayoutContentBody(_a, ref) {
    var _b;
    var full = _a.full, children = _a.children, className = _a.className, props = __rest(_a, ["full", "children", "className"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-layout__content-body", className) }, props),
        React.createElement("div", { className: classNames(classPrefix + "-layout__content-body-inner", (_b = {},
                _b[classPrefix + "-layout__content-body-inner--full"] = full,
                _b)) }, children)));
});
LayoutContentBody.displayName = "LayoutContentBody";
var LayoutContentFooter = createRocket("LayoutContentFooter", "div.@{prefix}-layout__content-footer");
export var LayoutContent = Object.assign(createRocket("LayoutContent", "main.@{prefix}-layout__content", "div.@{prefix}-layout__content-inner"), {
    Header: LayoutContentHeader,
    Body: LayoutContentBody,
    Footer: LayoutContentFooter,
});
//# sourceMappingURL=LayoutContent.js.map